import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import axios from 'axios'
import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'

const app = createApp(App)

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
window.axios = axios
/*window.aut_asset = {
  id: 2351,
  uid: '36e-9c5-7a0-5db',
  name: 'Teststation Software F&E',
  image: 'storage/83e4ca99-913d-44bc-a97a-3ec4f24690a7.jpg',
  activeservices: [],
  account: {
    name: 'Test',
    _translations: [],
  },
  modeltype: 'device',
  _translations: {
    name: 'en',
    description: 'en',
  },
}
window.aut_access_token =
  'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNzY5YWZiNWRiYzRmNzAyYzUzMWU5OWYzNzY3YjBmMTM3MTU1Yjc2NjQ3NzUxYjgwZTkwZjc4NmNkM2VjNTYwYzA3NTNkMTQ1NGI1Y2M5Y2IiLCJpYXQiOjE3MzYxMTQxODkuODU1OTU0LCJuYmYiOjE3MzYxMTQxODkuODU1OTU2LCJleHAiOjE3Njc2NTAxODkuODQ3MDY3LCJzdWIiOiIxMjgiLCJzY29wZXMiOlsiKiJdfQ.PQVCHhmJnkpJQuNcwMtnHNZG4Xa5bO2-qIRBUL6CJM94lMiuD_3UpGBLhUdImTQ5w06f6pme6ARmn4slZasKqO01KVd9WkzuXJdi1x6ylcr_fUbJsOS__SdDoRCi3mJkfYCbIfzQ-I-Q8XdIAZ2IrRyfl955-7jK1F-l7cd_-U1JdAJrFVv6qS1i_FBHJIS-9vwqK4Oq_FmJWbHoJPjOkr6HIc4K-uzbnONhaxyrCZ3IV9LSnU2bsSkQB2XjxuSYfbex-SgtCAYvhD85yizjMh4VYDN0ur5tC2bBy5Wk9GeOZQZ-FyNhxQ65fz378gYAdaYau18DwPC-8aQpfAqgNc0ICZhEuFtPwih6GJ6vd6td4iSJojKGuNmiLfnJO2hP4MF0QrE1sllvWvrI6E5oCAtdjLMQLSC32SFIFJHyrWzgJ-T92waK2v1RyUAiML58M9GbsHIbDGPIbXS8EP8Mjd8mQfTISBxH7c21Nlp_jMf3myqDWPA4W7O6JoJ4bF5lYSUcwJBluy1fZJ_LeWCDdOjPAQ8GM-RMsGvbFg30J5pfMVKvhWyMXnLmEHckSR0vo8ieoIB1-Av8eSASeW-5JJ0VogiE5YEeFp794dU5wRe7p8Ie93LNPRWPyRFXOCkFZH0EjPU6QR9AMUNLV7sYpHZdT0RakLhXU7HFTYRdUcU'*/
app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}
var init = false
window.addEventListener(
  'message',
  (event) => {
    //console.log(event)
    Object.assign(window, { ...event.data })

    // console.log('ACCESS TOKEN', window.aut_access_token)
    window.axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: 'Bearer ' + window.aut_access_token,
    }
    if (!init) {
      init = true
      app.mount('#app')
    }
  },
  false,
)
